<template>
<div class="container-fluid">
    <div class="row">
        <div class="col-12">
            <h1 data-test="pageTitle">Manage Asset Types</h1>
        	<div class="card">
                <table class="table table-hover">
                	<thead>
                		<th>ID</th>
                		<th>Label</th>
                		<th>Actions</th>
                	</thead>
                	<tr v-for="assetType in assetTypes">
                		<td>
                			<label>{{ assetType.id }}</label>
                		</td>
                		<td>
                			<template v-if="assetType.id === editing.id">				
                				<input class="form-control" v-model="editing.label">
                			</template>
                			<template v-else>
                				{{ assetType.label }}
                			</template>
                		</td>
                		<td>
                			<template v-if="assetType.id === editing.id">
                				<button class="btn btn-primary" @click="updateAssetType(assetType.id)">Save</button>
                				<button class="btn btn-outline-secondary" @click="resetEditing(assetType.id)">Cancel</button>
                				<button class="btn btn-outline-warning" @click="deleteAssetType(assetType.id)">Delete</button>
                			</template>

                			<template v-else>
                				<button class="btn btn-outline-primary" @click="setEditing(assetType.id)">edit</button>
                			</template>
                		</td>
                	</tr>
                </table>
                <div class="card-body">
                	<div class="form-inline">
                		<label class="mr-3">Add new asset type:</label>
                		<input class="form-control mr-2" v-model="newAssetType.label" placeholder="Asset type name">
                		<button class="btn btn-primary" @click="addAssetType()">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
    import BreadcrumbsManager from '../../helpers/BreadcrumbManager';

	export default {
        mixins: [BreadcrumbsManager],

        data() {
            return {
                assetTypes: [],

                newAssetType: {
                	label: '',
                },

                editing: {
                	id: '',
                	label: '',
                },

                oldLabel: '',
            }
        },

        created() {
        	this.fetchAssetTypes();
        },

        activated() {
            this.setBreadcrumbs([
                { text: 'Home', to: { name: 'home' } },
                { text: 'Settings', to: { name: '' } },
                { text: 'Asset Types', to: { name: 'admin.asset_types' } },
            ]);
        },

        methods: {
        	fetchAssetTypes() {
                axios.get(`/api/asset-types`).then(({data}) => {
                    this.assetTypes = data;
                })
        	},

        	addAssetType() {
        		axios.post('/api/asset-types', this.newAssetType).then(({data}) => {
                    this.assetTypes.push(data);
                })
        	},

        	setEditing(id) {
        		this.editing.id = id;
        		this.editing.label = this.assetTypes.find(x => x.id === id).label;
        		this.oldLabel = this.assetTypes.find(x => x.id === id).label;

        	},

        	resetEditing(id) {
        		this.editing.id = '';
        		this.assetTypes.find(x => x.id === id).label = this.oldLabel;

        	},

            updateAssetType(id) {
                axios.put(`/api/asset-types/${id}`, this.editing).then(({data}) => {
                    this.assetTypes.find(x => x.id === id).label = data.label;
                    this.setEditing(0);
                })
            },

            deleteAssetType(id) {
                Swal.fire({
                    title: 'Are you sure?',
                    text: 'You will not be able to recover this asset type!',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Delete asset type',
                    cancelButtonText: 'Keep asset type',
                    animation: false,
                    }).then((result) => {
                        if (result.value) {
                            axios.delete(`/api/asset-types/${id}`, id).then(() => {
                            	let index = this.assetTypes.map(function (lines) { return lines.id; }).indexOf(id);
                            	this.assetTypes.splice(index, 1);
                            })
                        }
                    }
                );
            },
        },
    }
</script>